<template>
  <div>
    <router-view
      v-if="!loading"
      :class="`theme-${theme}`"
      v-slot="{ Component }"
    >
      <transition name="page-transition" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <AppPageSpinner v-if="loading" />
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import AppPageSpinner from "@/components/UI/AppPageSpinner";

export default {
  name: "DefaultScreen",
  components: { AppPageSpinner },
  data() {
    return {
      loading: true,
    };
  },
  provide() {
    return {
      setLoading: this.setLoading,
    };
  },
  computed: {
    ...mapGetters({ reservation: "booking/reservation" }),
    theme() {
      return (
        getComputedStyle(document.body)
          .getPropertyValue("--theme")
          .toString()
          .replace(/['"]+/g, "")
          .trim() || "dark"
      );
    },
    currentPath() {
      const lastAction = this.reservation?.["reservation"]?.["last_action"];
      if (
        this.reservation.reservation.status === "INHOUSE" &&
        this.reservation.checkout !== null
      ) {
        if (
          [
            "checkout_success",
            "checkout_waiting",
            "checkout_late",
            "checkout_failed",
          ].includes(lastAction)
        ) {
          return "bill";
        }
        return "checkOutStart";
      }
      switch (lastAction) {
        case "update_agreements":
          return "start";
        case "update_profiles":
          if (this.reservation?.["upsell"]?.["items"]) return "upSale";
          return "summary";
        case "update_signature":
          return "summary";
        case "create_order":
          return "summary";
        case "finish_checkin":
          return "ThankYou";
        default:
          return "welcome";
      }
    },
  },
  methods: {
    ...mapMutations({
      SET_HOTEL: "booking/SET_HOTEL",
      SET_RESERVATION: "booking/SET_RESERVATION",
    }),

    getStruct(uid, hash) {
      return this.$axios.get(`/web/v2/${uid}/struct?hash=${hash}`);
    },
    setLoading(value) {
      this.loading = value;
    },
    /*getView(uid, hash) {
      return this.$axios.get(`/web/v2/${uid}/view?hash=${hash}`);
    },*/
  },
  created() {
    const { uid, hash } = this.$route.params;
    let file = document.createElement("link");
    file.rel = "stylesheet";
    file.href = `${process.env.VUE_APP_BACKEND_API}/web/v2/${uid}/css?hash=${hash}`;
    document.head.appendChild(file);
    Promise.all([this.getStruct(uid, hash)])
      .then(([res]) => {
        const prepended = res.data;
        prepended["reservation"]["profiles"] = prepended["reservation"][
          "profiles"
        ].map((profile) => {
          !profile["uploadedDocuments"]
            ? (profile["uploadedDocuments"] = [])
            : true;
          return profile;
        });
        this.SET_RESERVATION(prepended);
        if (this.currentPath && this.$route.meta.startPage) {
          this.$router
            .push({ path: this.currentPath, query: this.$route.query })
            .then(() => {
              this.loading = false;
            });
        } else {
          this.loading = false;
        }
      })
      .catch(() => {
        this.$router
          .push({ name: "notFoundScreen", params: { locale: "en" } })
          .then(() => {
            this.loading = false;
          });
      });
  },
};
</script>

<style>
.page-transition-enter-active,
.page-transition-leave-active {
  transition: 0.15s ease-in-out;
}
.page-transition-enter-from,
.page-transition-leave-to {
  opacity: 0;
  transform: scale(0.99);
}
</style>
